import SessionSchedule from './';
import Interval from 'domain/Interval';
import is from 'is_js';

export const create = (data) => new SessionSchedule(data)
    .update('period', (duration) => updateValue(duration));

export default create;

function updateValue(value) {
  if (is.undefined(value)) {
    return undefined;
  }

  return Interval.create(value);
}



// WEBPACK FOOTER //
// ./containers/Group/GroupSummary/SessionSchedule/create.js